import React from 'react';
import type { IconProps } from '../types';

export const LoadingOHIFMark = (props: IconProps) => (
  <svg
    width="141"
    height="131"
    viewBox="0 0 70 64"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
   >
    <g
      transform="scale(2)"
      fillRule="nonzero"
    >
      <rect
        x="1"
        y="1"
        width="33"
        height="30"
        stroke="#990000"
        strokeWidth="0.8"
        fill="none"
        rx="2"
      />
      <text
        x="17"
        y="17"
        textAnchor="middle"
        fill="#FFF"
        fontSize="8.5"
        fontFamily="Arial"
        dominantBaseline="middle"
        fontWeight="bold"
      >
        Clarify
      </text>
    </g>
  </svg>
);

export default LoadingOHIFMark;
